// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"f81fe41a","186":"49d6f565","213":"412d4ea5","351":"a2064294","667":"bbf3e765"}[chunkId] + ".chunk.js";
};